import { atom } from "jotai";
import { AxiosInstance } from "axios";
import { ApiRegistration } from "src/api/types";
import useApi, {
	ApiActions,
	ApiStatus,
	emptyApiState,
	Pagination,
} from "src/hooks/api/utils/useApi";

type State = {
	registrations: ApiRegistration[];
	status: ApiStatus;
	actions: ApiActions;
	api: AxiosInstance;
	pagination: Pagination;
};

const registrationsAtom: any = atom(emptyApiState);

type Options = {
	task_id?: number;
	filter?: any;
};

function useRegistrations(options?: Options): State {
	const { state, actions, api, pagination } = useApi(registrationsAtom, {
		baseUrl: "/company/registrations",
		query: {
			task_id: options?.task_id,
			...(options?.filter || {}),
		},
	});

	return {
		registrations: state?.list || [],
		status: state.status,
		pagination,
		actions,
		api,
	};
}

export default useRegistrations;
